import { Component, OnInit } from '@angular/core';
import { AchooPopupComponent } from '../../../core/achoo-popup/achoo-popup.component';

@Component({
  selector: 'message-popup',
  templateUrl: './message-popup.component.html',
  styleUrls: ['./message-popup.component.scss']
})
export class MessagePopupComponent extends AchooPopupComponent {
  constructor() {
    super();
  }
}



// WEBPACK FOOTER //
// ./src/app/main/influencer-home/message-popup/message-popup.component.ts